var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[(!_vm.isSimpleMode)?_c('PromoBar'):_vm._e(),(_vm.$device.isSmall)?_c('MobileHeader'):_c(_vm.headerComponent,{tag:"component"}),(!_vm.isSimpleMode)?_c('Navbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }